import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // Uncomment for production
import FileSaver from 'file-saver';
import { simpleGetCall, simpleGetCallWithErrorResponse } from '../Api/ApiServices';
import { ApiConfig } from '../Api/ApiConfig';
import { toastMsg } from '../component/toast';



/**
 * ============================================================================
 * 1. CONFIGURATION & THEME
 * ============================================================================
 */
const THEME_COLORS = {
    primary: '#0d6efd',
    success: '#198754',
    warning: '#ffc107',
    danger: '#dc3545',
    info: '#0dcaf0',
};


/**
 * ============================================================================
 * 2. ICONS
 * ============================================================================
 */
const Icons = {
    Download: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" x2="12" y1="15" y2="3" /></svg>,
    User: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>,
    Users: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>,
    Book: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" /><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" /></svg>,
    Brain: () => <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z" /><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z" /></svg>,
    Briefcase: () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect width="20" height="14" x="2" y="7" rx="2" ry="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></svg>,
    Check: () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="m9 12 2 2 4-4" /></svg>,
    XCircle: () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="m15 9-6 6" /><path d="m9 9 6 6" /></svg>,
    Info: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><path d="M12 16v-4" /><path d="M12 8h.01" /></svg>,
    Alert: () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" /><path d="M12 9v4" /><path d="M12 17h.01" /></svg>,
    MoreVertical: () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="1" /><circle cx="12" cy="5" r="1" /><circle cx="12" cy="19" r="1" /></svg>,
    Home: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></svg>,
    List: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" /></svg>,
    LogOut: () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" x2="9" y1="12" y2="12" /></svg>,
    Target: () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" /></svg>,
};


/**
 * ============================================================================
 * 3. SHARED UI COMPONENTS
 * ============================================================================
 */
function Card({ children, className = "", style = {} }) {
    // Bootstrap standard card: reduced margin bottom (mb-3) and internal padding (p-3)
    return (
        <div className={`card shadow-sm border-0 mb-3 ${className}`} style={style}>
            <div className="card-body p-3">
                {children}
            </div>
        </div>
    );
}


function SectionHeader({ icon: Icon, title, iconColor = "blue" }) {
    // Using Bootstrap d-flex and margin utilities
    // 'icon-box' class relies on minimal custom CSS or can be replaced by Bootstrap utils if desired
    return (
        <div className="d-flex align-items-center mb-2 pb-1 border-bottom">
            {/* <div className={`icon-box icon-box-${iconColor} me-2`}>
                {Icon && <Icon />}
            </div> */}
            <h6 className="mainHeading interRegular m-0">{title}</h6>
        </div>
    );
}


// Modal Component
const PersonalityDetails = ({ isOpen, per, handleShowPersonality }) => {
    if (!isOpen) return null;

    // Using Bootstrap modal classes structure
    return (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content shadow border-0">
                    <div className="modal-header border-bottom-0 py-2">
                        <h6 className="modal-title fw-bold">{per} Details</h6>
                        <button type="button" className="btn-close" onClick={() => handleShowPersonality(null, false)} aria-label="Close"></button>
                    </div>
                    <div className="modal-body text-muted small py-2">
                        <p className="mb-0">Detailed analysis for the <strong>{per}</strong> personality type would appear here. This typically includes detailed behavioral traits, communication preferences, and specific management advice tailored to this specific aspect of the candidate's profile.</p>
                    </div>
                    <div className="modal-footer border-top-0 py-2">
                        <button type="button" className="btn btn-secondary btn-sm" onClick={() => handleShowPersonality(null, false)}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
}


const SummarySkeleton = () => (
    <div className="placeholder-glow">
        <div className="placeholder col-4 mb-2 bg-secondary rounded" style={{ height: '24px' }}></div>
        <div className="placeholder col-12 mb-1 bg-light rounded"></div>
        <div className="placeholder col-12 mb-1 bg-light rounded"></div>
        <div className="placeholder col-8 bg-light rounded"></div>
    </div>
);




/**
 * ============================================================================
 * 4. VIEW COMPONENTS (Render Logic)
 * ============================================================================
 */


const ViewExecutive = ({ data, candidateSummary }) => (
    <div className="fade-in-up">
        {/* Profile Header & Behaviors Card */}
        <div className="card shadow-sm border-0 mb-3">
            <div className="card-body p-3">
                {/* Header Row */}
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-2 pb-2 border-bottom">
                    <div className="mb-2 mb-md-0">
                        <h2 className="mainHeading interRegular mb-0">{candidateSummary?.candidateName}</h2>
                        {/* <p className="text-muted small fw-medium mb-0">{candidateSummary?.primaryProfileName} & {candidateSummary?.secondaryProfileName}</p> */}
                    </div>
                    <div className="text-md-end">
                        <h3 className="mainHeading interRegular mb-0">{candidateSummary?.forPosition}</h3>
                        <div className="xlNormalText interRegular">{candidateSummary?.forCompany}</div>
                    </div>
                </div>

                {/* Behaviors Grid - Compact */}
                <div>
                    <h6 className="text-uppercase xlText interRegular subHeadongTextColor" style={{ letterSpacing: '0.5px' }}>Behaviors identified as most relevant</h6>
                    <div className="row g-2">
                        {candidateSummary?.selectedBehaviourMatch1?.map((item, i) => (
                            <div key={i} className="col-12 col-md-6 col-lg-3">
                                <div className="h-100 p-1">
                                    <div className="subHeading interRegular mb-0" >{item?.behaviourName}</div>
                                    <div className="headingShortText interRegular subHeadongTextColor">{item?.description}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>


        {/* Narrative Summary Content */}
        <Card>
            <SectionHeader icon={Icons.Brain} title="Summary" iconColor="blue" />
            <div>
                {[
                    { title: data?.title, text: data?.final_summary },
                    { title: "The Overall Personality", text: data?.overall_personality, descr: data?.overall_description },
                    { title: "Self Image", text: data?.self_image, descr: data?.self_description },
                    { title: "The Natural Personality", text: data?.natural_personality, descr: data?.natural_description }
                ].map((section, idx) => (
                    <div key={idx} className="mb-3 last:mb-0">
                        <h6 className="text-primary subHeading interRegular text-uppercase mb-1" >{section.title}</h6>
                        <p className="xlNormalText interRegular subHeadongTextColor  text-justify mb-1" style={{ lineHeight: '1.4' }}>{section?.descr}</p>
                        <p className="xlNormalText interRegular subHeadongTextColor mb-0" style={{ lineHeight: '1.4' }}>{section.text}</p>
                    </div>
                ))}
            </div>
        </Card>


        {/* Strengths & Challenges */}
        <Card>
            <SectionHeader icon={Icons.Target} title="Strengths & Challenges" iconColor="orange" />
            <p className="xlNormalText interRegular subHeadongTextColor mb-3" >
                A breakdown of natural professional assets and potential behavioral blockers.
            </p>
            <div className="row g-3">
                {/* Strengths */}
                <div className="col-md-6">
                    <div className="h-100 p-2 rounded bg-success-subtle border border-success-subtle">
                        <h6 className="subHeading interRegular text-success mb-2 d-flex align-items-center" >
                            <span className="me-2 d-flex  "><Icons.Check /></span> Key Strengths
                        </h6>
                        {data?.strengths.map((s, i) => (
                            <div key={i} className="d-flex gap-2 mb-1 align-items-start">
                                <span className="text-success subHeading mt-1" style={{ fontSize: '8px' }}>●</span>
                                <span className="text-dark xlNormalText interRegular" >{s?.description}</span>
                            </div>
                        ))}
                    </div>
                </div>
                {/* Challenges */}
                <div className="col-md-6">
                    <div className="h-100 p-2 rounded bg-warning-subtle border border-warning-subtle">
                        <h6 className="subHeading interRegular text-warning-emphasis mb-2 d-flex align-items-center">
                            <span className="me-2 d-flex"><Icons.Alert /></span> Development Areas
                        </h6>
                        {data?.challenges.map((w, i) => (
                            <div key={i} className="d-flex gap-2 mb-2 align-items-start">
                                <span className="text-warning-emphasis d-flex" style={{ marginTop: '2px' }}><Icons.Info /></span>
                                <div>
                                    <strong className="d-block subHeading interRegular" >{w.title}</strong>
                                    <p className="xlNormalText interRegular mb-0" >{w.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </Card>


        {/* Communication Style */}
        <Card>
            <SectionHeader icon={Icons.Users} title="Communication Style" iconColor="blue" />
            <div className="p-2 rounded bg-info-subtle border border-info-subtle">
                <p className="text-info-emphasis mb-0 xlNormalText interRegular">{data?.communication_style}</p>
            </div>
        </Card>


        {/* Methodology */}
        <Card>
            <SectionHeader icon={Icons.Book} title="Assessment Framework" iconColor="purple" />
            <div className="mb-3">
                <h6 className="text-primary subHeading interRegular mb-1" >Our Approach</h6>
                <p className=" xlNormalText interRegular">
                    {data?.assessmentFramework?.description}
                </p>
            </div>
            {/* <div className="row g-2 mb-3">
                {
                    data?.assessmentFramework?.points?.map((item, i) => {
                        return <div className="col-md-4" key={i}>
                            <div className="p-2 border rounded bg-light h-100">
                                <h6 className=" mb-1 subHeading interRegular">{i + 1}. {item?.title}</h6>
                                <p className="mb-0 interRegular subHeadongTextColor subHeadingNormal">{item?.description}</p>
                            </div>
                        </div>
                    })
                }


            </div> */}
            <div className="p-2 rounded bg-danger-subtle border border-danger-subtle d-flex gap-2 align-items-start">
                <div className="text-danger d-flex" style={{ marginTop: '2px' }}><Icons.Alert /></div>
                <div>
                    <h6 className="text-danger subHeading interRegular text-uppercase mb-0" >Notice of Use & Liability</h6>
                    <p className="text-danger interRegular  subHeadingNormal mb-0" >
                        {data?.assessmentFramework?.notice?.text}
                    </p>
                </div>
            </div>
        </Card>
    </div>
);


/**
 * ============================================================================
 * 5. STYLE ENGINE
 * (Minimal overrides to support custom icon colors & branding)
 * ============================================================================
 */
const StyleEngine = () => (
    <style dangerouslySetInnerHTML={{
        __html: `
    @import url("https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css");
    @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");


    :root {
      --bs-body-font-family: 'Inter', sans-serif;
      --bs-body-bg: #f5f8ff;
      --brand-primary: ${THEME_COLORS.primary};
    }


    body {
      background-color: var(--bs-body-bg);
    }


    /* Custom Utilities to augment Bootstrap */
    .icon-box {
      width: 24px;
      height: 24px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
    .icon-box-blue { background-color: #eef2ff; color: #0d6efd; }
    .icon-box-green { background-color: #d1e7dd; color: #198754; }
    /* UPDATED ORANGE: Better contrast */
    .icon-box-orange { background-color: #fff1e5; color: #fd7e14; }
    .icon-box-purple { background-color: #faf5ff; color: #6f42c1; }
    .icon-box-red { background-color: #f8d7da; color: #dc3545; }


    .fade-in-up {
        animation: fadeInUp 0.4s ease-out forwards;
    }
    @keyframes fadeInUp {
        from { opacity: 0; transform: translateY(10px); }
        to { opacity: 1; transform: translateY(0); }
    }
   
    .report-wrapper {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }
    .report-content {
        flex: 1;
        padding-top: 1rem;
        padding-bottom: 1rem;
    }
  `}} />
);


/**
 * ============================================================================
 * 6. MOCK DATA
 * ============================================================================
 */
const MOCK_DATA = {
    candidateSummary: {
        candidateName: "Mamtha",
        primaryProfileName: "The Motivator",
        secondaryProfileName: "The Influencer",
        traitsResult: {
            most: { 1: "Adventurous", 2: "Charming", 3: "Possessive", 4: "Obstinate" },
            diff: { 1: "Competitive", 2: "Pleasant", 3: "Deliberate", 4: "Defiant" }
        }
    },
    candidatePersonality: {
        data: {
            personality_report: {
                title: "Motivator & Influencer",
                final_summary: "Mamtha exhibits a unique blend of traits that define her overall personality as competitive, pleasant, deliberate, and defiant. Her personality is characterized by a dynamic interplay between her natural instincts and adapted behaviors, which together create a complex yet harmonious individual.",
                overall_personality: "Mamtha's personality is a fascinating amalgamation of competitiveness, pleasantness, deliberation, and defiance. Her competitive spirit is a driving force that propels her to strive for excellence and achieve her goals. This trait is balanced by her pleasant nature.",
                self_image: "Mamtha's self-image is shaped by her perception of herself as a calculated risk-taker, self-promoting, stable, and rigid individual. This self-perception influences how she presents herself to the world and interacts with others in a work environment.",
                natural_personality: "Mamtha's natural personality is defined by her adventuresome, charming, possessive, and obstinate traits. These characteristics reveal her true self, which emerges when she is relaxed and comfortable in her environment.",
                stratergic_insights: {
                    best_role: "Environments that encourage innovation, recognize individual contributions, and value strategic risk-taking.",
                    management_tips: "Encourage her competitive spirit and foster an environment that values strategic thinking.",
                    key_risks: "Potential resistance to change or new ideas due to rigidity. May become possessive in collaborative settings."
                },
                dos_and_donts: {
                    dos: [
                        { description: "Encourage competitive spirit by setting challenging goals." },
                        { description: "Foster an environment that values strategic thinking." },
                        { description: "Provide opportunities to showcase strengths." }
                    ],
                    donts: [
                        { description: "Avoid imposing rigid structures that stifle adventurous nature." },
                        { description: "Refrain from dismissing her ideas or contributions." }
                    ]
                },
                strengths: [
                    { description: "Competitive drive and strategic thinking" },
                    { description: "Charismatic and pleasant demeanor" },
                    { description: "Ability to build positive relationships" }
                ],
                challenges: [
                    { title: "RIGIDITY", description: "Potential resistance to change or new ideas." },
                    { title: "POSSESSIVENESS", description: "May become overly protective of tasks/territory." }
                ],
                conflict_potential: "Defiant nature may lead to questioning authority. Possessiveness and obstinacy can create friction in collaboration.",
                communication_style: "Charming, persuasive, and articulate. Her natural charisma enhances her ability to influence and inspire others.",
                team_fit_summary: {
                    ideal_environment: "Innovation-focused, recognizing individual contributions, and valuing strategic outcomes."
                }
            }
        }
    }
};


/**
 * ============================================================================
 * 7. MAIN COMPONENT
 * ============================================================================
 */
export default function PersonalityReport({ data }) {
    const { code, userId } = useParams()
    const [isLoading, setIsLoading] = useState(false);
    const [candidateDetails, setCandidateDetails] = useState(null);
    const navigate = useNavigate();

    const [personalitDetails, setPersonalityDetails] = useState({
        isOpen: false,
        per: ""
    });


    // Use passed data if available (e.g. from parent component), otherwise fetch
    useEffect(() => {
        if (data) {
            setCandidateDetails(data);
        } else {
            getDetailedReport();
        }
    }, [data]);


    const getDetailedReport = () => {
        setIsLoading(true);
        simpleGetCall(ApiConfig.GET_DETAILED_PERSONALITY_REPORT + `?userId=${userId}&code=${code}`).then((res) => {
            if (res?.succeded) {
                document.title = res?.response?.candidateSummary?.candidateName + " - Detailed Personality";
                setCandidateDetails(res?.response);
            } else {
                toastMsg('error', res?.message || 'Failed to fetch report details');
            }
            setIsLoading(false);
        });
    };


    const handlePersonality = useCallback((per, isOpen) => {
        setPersonalityDetails({
            isOpen: isOpen,
            per: per
        });
    }, []);


    const downloadPersonality = () => {
        simpleGetCallWithErrorResponse(ApiConfig.DOWNLOAD_PERSONALITY_REPORT + `?userId=${userId}&code=${code}`).then((res) => {
            if (res?.json?.succeded) {
                FileSaver.saveAs(
                    `data:application/pdf;base64,${res?.json?.response.pdfBase64}`,
                    (candidateDetails?.candidateSummary?.candidateName || 'Report') + '_Personality_Report.pdf'
                );
            }
        });
    };


    return (
        <div className="report-wrapper">
            <StyleEngine />
            {/* Header */}
            <header className="navbar navbar-light bg-white border-bottom sticky-top px-3 py-2 shadow-sm">
                <div className="container-fluid d-flex justify-content-between align-items-center">
                    <img src="https://lywo.in/images/logo.svg" alt="Lywo Logo" style={{ height: '32px' }} />
                    <button
                        onClick={downloadPersonality}
                        className="btn btn-primary btn-sm d-flex align-items-center gap-2 fw-semibold"
                    >
                        <Icons.Download /> <span className="d-none d-sm-inline">Download PDF</span>
                    </button>
                </div>
            </header>


            {/* Main Content */}
            <div className="container report-content">
                <main aria-live="polite">
                    {isLoading ? (
                        <Card>
                            <SummarySkeleton />
                        </Card>
                    ) : (
                        <ViewExecutive data={candidateDetails?.candidatePersonality?.data?.personality_report} candidateSummary={candidateDetails?.candidateSummary} />
                    )}
                </main>
            </div>


            {/* Modal */}
            <PersonalityDetails
                isOpen={personalitDetails?.isOpen}
                per={personalitDetails?.per}
                handleShowPersonality={handlePersonality}
            />
        </div>
    );
}

